import { useEffect, useState } from 'react';

// Matches SCSS breakpoints exactly:
// $breakpoint-tablet-min: 48rem | $breakpoint-desktop-min: 75rem
export const BREAKPOINTS_REM = {
  tabletMin: 48,
  desktopMin: 75,
} as const;

// Converts rem to px using the document root font size — keeps JS in sync with CSS media queries
const remToPx = (rem: number): number =>
  rem * parseFloat(getComputedStyle(document.documentElement).fontSize);

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      if (typeof window === 'undefined') return;
      setIsMobile(window.innerWidth < remToPx(BREAKPOINTS_REM.tabletMin));
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile;
};

export const useIsMobileOrTablet = () => {
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  useEffect(() => {
    const check = () => {
      if (typeof window === 'undefined') return;
      setIsMobileOrTablet(window.innerWidth < remToPx(BREAKPOINTS_REM.desktopMin));
    };

    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return isMobileOrTablet;
};
